// extracted by mini-css-extract-plugin
export default {"pageNotFound":"PageNotFound_pageNotFound__Nqzt3","image":"PageNotFound_image__4Qo8y","title":"PageNotFound_title__eiMaB","description":"PageNotFound_description__+dI+4"};